export var DEVICE_TYPE_SMARTPHONE='smartphone';export var DEVICE_TYPE_TABLET='tablet';